<template>
  <div class="commission-settings py-5 px-4">
    <v-container class="custom-container">
      <v-row dense class="no-gutters">
        <v-col cols="12">
          <v-card
            class="deposit-form create-account-form"
            :color="$vuetify.theme.dark ? 'transparent' : 'transparent'"
          >
            <v-row dense>
              <v-col cols="12" sm="6" md="6" lg="2">
                <v-select
                  solo
                  :items="slots1"
                  append-icon="mdi-chevron-down"
                  label="Tire"
                  class="custom-select"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <v-select
                  solo
                  :items="slots2"
                  append-icon="mdi-chevron-down"
                  label="Level"
                  class="custom-select"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <v-select
                  solo
                  :items="slots3"
                  append-icon="mdi-chevron-down"
                  label="Account Type"
                  class="custom-select"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <v-select
                  solo
                  :items="slots4"
                  append-icon="mdi-chevron-down"
                  label="Currency Group"
                  class="custom-select"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="4" class="text-right">
                <AddDefaultCommissionModal></AddDefaultCommissionModal>
              </v-col>
            </v-row>
            <v-row dense class="pb-5">
              <v-col cols="12">
                <commission-settings-data-table></commission-settings-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddDefaultCommissionModal from "@/components/Partners/AddDefaultCommissionModal.vue";
import CommissionSettingsDataTable from '@/components/Partners/CommissionSettingsDataTable.vue';

export default {
  data() {
    return {
      slots1: [1, 2, 3],
      slots2: ["Level 1", "Level 2", "Level 3"],
      slots3: ["Hero ACC", "B", "C"],
      slots4: ["Major", "B", "C"],
    };
  },
  components: { AddDefaultCommissionModal, CommissionSettingsDataTable },
};
</script>


